export const setStyle = (target, property, value) => {
    const initial = target.style.getPropertyValue(property);
    target.style.setProperty(property, value);
    return () => {
        target.style.setProperty(property, initial);
    };
};
//# sourceMappingURL=setStyle.js.map